import { useContext } from 'react';
import { Base } from 'zf-web-components';
import { Icons } from 'zf-web-components/icons';
import { observer } from 'mobx-react-lite';
import { RootContext } from '@stores';
import styles from './style.module.less';
import type { ReactElement } from 'react';

/**
 * 菜单折叠器
 */
function CollapseComponent(): ReactElement {
  const { shared } = useContext(RootContext);
  const { token } = Base.theme.useToken();

  if (shared.collapsed) {
    return (
      <Icons name='MenuUnfoldOutlined'
        className={styles.reorderIcon}
        style={{ color: token.colorBgBase }}
        onClick={() => shared.setCollapsed(!shared.collapsed)}
      />
    );
  }
  return (
    <Icons
      name='MenuFoldOutlined'
      className={styles.reorderIcon}
      style={{ color: token.colorBgBase }}
      onClick={() => shared.setCollapsed(!shared.collapsed)}
    />
  );
}

export const Collapse = observer(CollapseComponent);
